export default "__VITE_ASSET__CxO4L430__"